"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-grid;\n  grid-auto-flow: column;\n  div.label {\n    grid-row: 1;\n    padding: 0 4px;\n    font-size: 12px;\n    font-weight: 500;\n    color: ", ";\n  }\n  div.input {\n    grid-row: 2;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    &.with-background {\n      box-shadow: inset 0 0 0 1px ", ";\n      background: ", ";\n    }\n  }\n  & > div > div, & > div > label {\n    display: grid;\n    grid-auto-flow: row;\n    grid-template-rows: repeat(2, 1fr);\n    align-items: end;\n    height: 100%;\n  }\n  input, button {\n    border-radius: 0;\n  }\n  button {\n    width: 100%;\n    height: 100%;\n  }\n  & > div:first-of-type input, & > div:first-of-type button {\n    border-radius: 0.25em 0 0 0.25em;\n  }\n  & > div:last-of-type input, & > div:last-of-type button {\n    border-radius: 0 0.25em 0.25em 0;\n  }\n\n  @media(max-width: 45em) {\n    grid-auto-flow: row;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var InputRow = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.colors.gray[900];
}, function (props) {
  return props.theme.colors.white[500];
}, function (props) {
  return props.theme.colors.white[800];
});

var _default = InputRow;
exports["default"] = _default;